<template>
  <WsUpdate
    :modelName="modelName"
    :modelVersionName="modelVersionName"
    :submodelName="submodelName"
    :submodelVersionName="submodelVersionName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :submodelFields="submodelFields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    editType="updateVersion"
    titleKey="last_version.name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/checklist_template";
import submodel from "@/models/checklist_question_template";
export default {
  data: () => ({
    modelName: model.modelName,
    modelVersionName: `${model.modelName}_version`,
    submodelName: submodel.modelName,
    submodelVersionName: "cklist_ques_tmp_ver",
    label: model.label,
    fields: model.fields,
    submodelFields: submodel.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["locales"],
            },
          ],
        },
      ],
    },
  }),
};
</script>